import React from 'react';

const TIERS = [
  { label: 'Tier 1 — up to £1,000', fee: '3.5%' },
  { label: 'Tier 2 — up to £10,000', fee: '2.5%' },
  { label: 'Tier 3 — up to £100,000', fee: '1.75%' },
  { label: 'Tier 4 — up to £1,000,000', fee: '1.0%' },
];

export default function FeeSchedule() {
  return (
    <div className="bg-tf-surface border border-tf-primary" data-testid="fee-schedule">
      <div className="px-4 sm:px-5 py-3 sm:py-4 border-b border-tf-primary">
        <h2 className="font-heading font-bold text-xs sm:text-sm tracking-[0.15em] sm:tracking-[0.2em] uppercase text-tf-text">Fee Schedule</h2>
      </div>
      <div>
        {TIERS.map((tier, i) => (
          <div key={i} className="px-4 sm:px-5 py-2.5 sm:py-3 border-b border-tf-border-muted last:border-b-0 flex items-center justify-between gap-2" data-testid={`fee-tier-${i}`}>
            <span className="font-body text-xs sm:text-sm text-tf-text">{tier.label}</span>
            <span className="font-heading font-bold text-xs sm:text-sm text-tf-accent flex-shrink-0">{tier.fee}</span>
          </div>
        ))}
      </div>
      <div className="px-4 sm:px-5 py-2.5 sm:py-3 bg-tf-bg">
        <p className="font-mono text-[9px] sm:text-[10px] text-tf-text-3 italic">Bespoke arrangements for transactions over £1,000,000.</p>
      </div>
    </div>
  );
}
